/**
 * @auther renjie.fei
 * 弹出层管理
 */
let zIndex = 1000
let instances = []

export default {
  generateIndex () {
    return zIndex++
  },

  push (instance) {
    instances.push(instance)
  },

  pop () {
    return instances.pop()
  },

  // 每一个instance都应该暴露close方法
  closeAll () {
    instances.forEach(instance => instance.close())
    instances = []
  }
}